import { Routes } from '@angular/router';

import { AuthGuard } from './shared/guard/auth-guard.service';

export const routes: Routes = [
  // Try to keep url path and component name equal. This ease code navigation and reduce amount of terms to remember.
  {
    path: 'login',
    loadComponent: () => import('./auth/component/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'logout',
    loadComponent: () => import('./auth/component/logout/logout.component').then((m) => m.LogoutComponent),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./auth/component/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: 'app',
    // Guards are used to protect routes of the app. If we try to access a protected place, the guard will refuse the navigation.
    // Here only logged in users can access this path.
    // See: https://angular.io/guide/router#preventing-unauthorized-access
    canActivate: [AuthGuard],
    // This lazy loads the routes only when accessing it (so only when we are logged in).
    // Why?
    // - Performance improvement: we only load routes we need (e.g. a simple user do not need to load the admin routes...).
    // - Guarding parts of the code: sometimes the code needs to be protected only for authorised users
    //     because it could contain proprietary or sensitive parts.
    // See: https://angular.io/guide/lazy-loading-ngmodules
    loadChildren: () => import('./main/main-routes').then((m) => m.routes),
  },
  // End of the routes. Angular router reaches here if it has matched nothing previously. So we redirect to our 404 route.
  { path: '', redirectTo: '/app/folders/all', pathMatch: 'full' },
  { path: '**', redirectTo: '/not-found' },
];
